var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "chat-module", staticStyle: { height: "100%" } },
    [
      _c("header", { staticClass: "chat-module__header" }, [
        _c("div", { staticClass: "chat-module__title" }, [
          _c("svg", { staticClass: "chat-module__icon" }, [
            _c("use", {
              attrs: {
                width: "14",
                height: "14",
                href: "/img/icons/sparkles.svg#icon-sparkles",
              },
            }),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "chat-module__label" }, [
            _vm._v("Optix AI"),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "chat-module__clear-btn",
            on: { click: _vm.onClearChat },
          },
          [_vm._v("\n      Clear\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "chat-module__separator" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chat-module__body" },
        [
          _c("AIEditorTab", {
            ref: "editor",
            attrs: { "target-element": _vm.targetElement },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }